import { Navigate, useParams, useLocation } from "react-router-dom";

// /p/:slug — SMS-friendly short link for partner storefronts.
// Preserves any query string (?qr=1 from QR posters) so scan
// tracking survives the redirect.
export default function ShortPartnerLink() {
  const { slug } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/pws-partner/${encodeURIComponent(slug || "")}${search || ""}`} replace />;
}
